import { useControllableState } from '../../../../core/hooks/useControllableState.js';
import { useDataTableConfigElement } from '../../../hooks/useDataTableConfig.js';
import type { DataTableRowData } from '../../row-data-types.js';
import type { DataTableOptions } from '../types/table.types.js';
import type {
  DataTableColumnSort,
  DataTableSortingProps,
} from './sorting-types.js';

const defaultSortBy: DataTableColumnSort[] = [];

/**
 * Configuration hook for the DataTable sorting feature.
 * @internal
 */
export function useSorting<TData extends DataTableRowData>(
  props: DataTableSortingProps,
  options: DataTableOptions<Exclude<TData, unknown>>,
): void {
  const configSortable = useDataTableConfigElement('sortable');

  const [sorting, setSorting] = useControllableState<DataTableColumnSort[]>({
    value: props.sortBy,
    defaultValue: props.defaultSortBy ?? defaultSortBy,
    onChange: props.onSortByChange,
  });

  const { sortable: sortableProp } = props;
  let sortable = false;

  if (sortableProp !== undefined) {
    if (typeof sortableProp === 'boolean') {
      sortable = sortableProp;
      // oxlint-disable-next-line react/immutability
      options.manualSorting = false;
    } else {
      sortable = true;
      // To do: should reconsider is there a better and simpler way (simpler API exposed) that we can check wheater the consumer wants to keep default sorting
      // or they want to implement custom data pre sorting
      if (sortableProp.manualSort === true) {
        // oxlint-disable-next-line react/immutability
        options.manualSorting = true;
      } else {
        // oxlint-disable-next-line react/immutability
        options.manualSorting = false;
      }
    }
  } else if (configSortable !== undefined) {
    if (typeof configSortable === 'boolean') {
      sortable = configSortable;
    } else {
      sortable = true;

      if (configSortable.manualSort === true) {
        // oxlint-disable-next-line react/immutability
        options.manualSorting = true;
      } else {
        // oxlint-disable-next-line react/immutability
        options.manualSorting = false;
      }
    }
  }

  // oxlint-disable-next-line react/immutability
  options.enableSorting = sortable;
  // oxlint-disable-next-line react/immutability
  options.state = {
    ...options.state,
    sorting,
  };
  // oxlint-disable-next-line react/immutability
  options.onSortingChange = setSorting;
}
